import { useTranslation } from "next-i18next";

export function StockWarning({ variant }) {
  const { t } = useTranslation("productpage");

  const only = t("only");
  const remainingSize = t("remaining-size");
  const areOnly = t("are-only");

  if (variant.title.includes("Donation")) return <></>;

  if (variant.quantityAvailable > 5 || variant.quantityAvailable < 0) return null;
  if (variant.quantityAvailable == 0) {
    return (
      <p>
        <b> {t("out-of-stock")} </b>
      </p>
    );
  }

  if (variant.quantityAvailable == 1) {
    return (
      <p>
        <b>
          {only} {variant.quantityAvailable} {remainingSize}
        </b>
      </p>
    );
  }

  return (
    <p>
      <b>
        {areOnly} {variant.quantityAvailable} {remainingSize}
      </b>
    </p>
  );
}
